import { IKeypadState } from '../../common/interfaces/states/IKeypadState';
import { store } from '../../common/redux/configure-store';
import { SalesKeypadActions } from '../../common/redux/reducers/sales-keypad-reducer';

export const setSalesKeypadState = (keypadState: Partial<IKeypadState>): void => {
  store.dispatch(SalesKeypadActions.setSalesKeypadState(keypadState));
};

export const getSalesKeypadState = (): IKeypadState => {
  return store.getState().salesKeypad;
};

export const resetSalesKeypadState = (): void => {
  store.dispatch(SalesKeypadActions.resetSalesKeypad());
};
